export interface AdminRbacQuery {
    QueryTable: {
        QueryStrings: string[];
    };
}

export interface AdminRbacQueryResponse {
    Results: boolean[];
}

export enum AdminCommands {
    newMailbox = 'New-Mailbox',
    setCalendarProcessing = 'Set-CalendarProcessing',
    getCalendarProcessing = 'Get-CalendarProcessing',
}

export enum AdminRoles {
    tenantPlacesManagement = 'TenantPlacesManagement',
    placesBuildingManagement = 'PlacesBuildingManagement',
    PlacesDeskManagement = 'PlacesDeskManagement',
}

export type AdminRbacQueryInput = AdminCommands | AdminRoles;
